/* eslint-disable vue/require-default-prop */

<script>
import Produto from '@src/services/produto_estoque'
import { VMoney } from 'v-money'

import tipoProdutoService from '../services/api-receituario/tipo-produto'
import unidadeService from '../services/api-receituario/unidade'
import produtorRuralService from '../services/produtor-rural'

export default {
  directives: { money: VMoney },
  props: {
    produto: {},
  },
  data() {
    return {
      is_defensivo: false,
      unidades: [],
      tipos_produto: [],
      produtores: [],
      fornecedorAutocompleteTerm: '',
      fabricanteAutocompleteTerm: '',
      fornecedorSearchDebounce: null,
      fabricanteSearchDebounce: null,
      showFornecedorAutocomplete: false,
      showFabricanteAutocomplete: false,
      isLoadingFornecedores: false,
      mapas: [],
      arquivoUploads: {
        foto_principal: [],
        fotos_secundarias: [],
        anexos: [],
        bula: [],
        fispq: [],
        manual: [],
      },
      arquivoPreviews: {
        foto_principal: [],
        fotos_secundarias: [],
        anexos: [],
        bula: [],
        fispq: [],
        manual: [],
      },
      activeTab: 0,
      filter: null,
      isLoading: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      percentMoney: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      mapasFields: [
        { key: 'nome', label: 'Nome', class: 'size-col-20' },
        { key: 'mapa', label: 'Mapa.', class: 'size-col-20' },
      ],
      situationOptions: [
        { value: true, text: 'Ativo' },
        { value: false, text: 'Inativo' },
      ],
      productTypeOptions: [
        'Defensivo',
        'Fertilizante',
        'Semente',
        'Biológico',
        'Corretivo',
        'Adjuvante',
        'Ração',
        'Medicamento',
        'Acessório',
        'Higiene',
        'Vacina',
        'Serviço',
        'Outro',
      ],
      originOptions: [
        '0 - Nacional',
        '1 - Estrangeira - importação direta',
        '2 - Estrangeira - adquirida no mercado interno',
        '3 - Nacional com conteúdo importado superior a 40%',
        '4 - Nacional conforme processos produtivos básicos',
        '5 - Nacional com conteúdo importado inferior ou igual a 40%',
        '6 - Estrangeira sem similar nacional',
        '7 - Estrangeira adquirida no mercado interno sem similar nacional',
        '8 - Nacional com conteúdo importado superior a 70%',
      ],
      cstIcmsOptions: ['00', '10', '20', '30', '40', '41', '50', '51', '60', '70', '90'],
      csosnOptions: ['101', '102', '103', '201', '202', '203', '300', '400', '500', '900'],
      pisCofinsOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '49', '50', '51', '52', '53', '54', '55', '56', '60', '61', '62', '63', '64', '65', '66', '67', '70', '71', '72', '73', '74', '75', '98', '99'],
      categoryOptions: ['Defensivos', 'Fertilizantes', 'Sementes', 'Nutrição Animal', 'Medicamentos', 'Pet Shop', 'Acessórios', 'Serviços'],
      subcategoryOptions: ['Herbicidas', 'Inseticidas', 'Fungicidas', 'Foliar', 'Solo', 'Rações', 'Higiene', 'Vacinas'],
      brandOptions: ['AgroMax', 'BioCampo', 'VetLife', 'NutriPet', 'Casa Verde', 'BlueLogic'],
      manufacturerOptions: ['Bayer', 'Syngenta', 'Basf', 'Ourofino', 'Ceva', 'Zoetis', 'Fabricante Próprio'],
      cultureOptions: ['Soja', 'Milho', 'Trigo', 'Algodão', 'Café', 'Hortaliças', 'Pastagem'],
      pestOptions: ['Lagarta', 'Percevejo', 'Ferrugem', 'Buva', 'Cigarrinha', 'Ácaros'],
      animalOptions: ['Cães', 'Gatos', 'Bovinos', 'Equinos', 'Suínos', 'Aves', 'Ovinos'],
      ageRangeOptions: ['Filhote', 'Adulto', 'Sênior', 'Todas as idades'],
    }
  },
  mounted() {
    this.ensureProductDefaults()
    this.normalizeProdutoParaFormulario()
    this.handleGet()
    this.handleGetTiposProduto()
    this.handleGetUnidade()
    this.handleGetProdutores()
    this.fornecedorAutocompleteTerm = this.produto.fornecedor_principal || ''
    this.fabricanteAutocompleteTerm = this.produto.fabricante || ''
    this.is_defensivo = this.produto.mapa !== undefined
  },
  watch: {
    produto: {
      handler() {
        this.ensureProductDefaults()
        this.normalizeProdutoParaFormulario()
        this.fornecedorAutocompleteTerm = this.produto.fornecedor_principal || ''
        this.fabricanteAutocompleteTerm = this.produto.fabricante || ''
        this.is_defensivo = this.produto.mapa !== undefined
      },
      immediate: true,
      deep: false,
    },
  },
  beforeDestroy() {
    if (this.fornecedorSearchDebounce) {
      clearTimeout(this.fornecedorSearchDebounce)
    }
    if (this.fabricanteSearchDebounce) {
      clearTimeout(this.fabricanteSearchDebounce)
    }
    this.limparArquivoPreviews()
  },
  methods: {
    ensureProductDefaults() {
      const defaults = {
        ativo: true,
        controla_estoque: true,
        controla_lote: false,
        controla_validade: false,
        permite_estoque_negativo: false,
        estoque_disponivel: 0,
        estoque_minimo: 0,
        estoque_maximo: 0,
        estoque_ideal: 0,
        ponto_reposicao: 0,
        fator_conversao: 1,
        margem_percentual: 0,
        comissao_vendedor_percentual: 0,
        aliquota_icms: 0,
        aliquota_pis: 0,
        aliquota_cofins: 0,
        especies_animais: [],
      }

      Object.keys(defaults).forEach((key) => {
        if (this.produto[key] === undefined || this.produto[key] === null) {
          this.$set(this.produto, key, defaults[key])
        }
      })
    },
    setLoading(value) {
      this.isLoading = value
    },
    normalizeText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
    },
    getFieldValue(source, keys) {
      const value = keys
        .map((key) => source && source[key])
        .find((item) => item !== undefined && item !== null && item !== '')

      if (value && typeof value === 'object') {
        return value.nome || value.descricao || value.label || value.name || value.valor || ''
      }

      return value || ''
    },
    matchOptionValue(options, value) {
      if (!value) {
        return ''
      }

      const normalizedValue = this.normalizeText(value)
      const match = options.find((option) => {
        const normalizedOption = this.normalizeText(option)
        return normalizedOption === normalizedValue ||
          normalizedOption.startsWith(normalizedValue) ||
          normalizedValue.startsWith(normalizedOption)
      })

      if (match) {
        return match
      }

      options.push(value)
      return value
    },
    normalizeBooleanValue(value, defaultValue = true) {
      if (value === true || value === false) {
        return value
      }

      if (value === 1 || value === '1') {
        return true
      }

      if (value === 0 || value === '0') {
        return false
      }

      const normalizedValue = this.normalizeText(value)

      if (['true', 'ativo', 'ativa', 'sim', 's', 'yes'].includes(normalizedValue)) {
        return true
      }

      if (['false', 'inativo', 'inativa', 'nao', 'n', 'no'].includes(normalizedValue)) {
        return false
      }

      return defaultValue
    },
    getFirstDefinedValue(source, keys) {
      return keys
        .map((key) => source && source[key])
        .find((value) => value !== undefined && value !== null && value !== '')
    },
    getMoneyFields() {
      return [
        'custo_medio',
        'ultimo_custo',
        'custo_reposicao',
        'valor_venda',
        'preco_promocional',
        'ultimo_preco_compra',
      ]
    },
    getPercentFields() {
      return [
        'margem_percentual',
        'comissao_vendedor_percentual',
      ]
    },
    getNumberFields() {
      return [
        'estoque_disponivel',
        'estoque_minimo',
        'estoque_maximo',
        'estoque_ideal',
        'ponto_reposicao',
        'fator_conversao',
        'aliquota_icms',
        'aliquota_pis',
        'aliquota_cofins',
        'prazo_medio_entrega',
      ]
    },
    parseBrazilianNumber(value) {
      if (value === undefined || value === null || value === '') {
        return null
      }

      if (typeof value === 'number') {
        return Number.isNaN(value) ? null : value
      }

      const textValue = String(value)
        .replace('R$', '')
        .replace('%', '')
        .trim()

      if (!textValue) {
        return null
      }

      const normalizedValue = textValue.includes(',')
        ? textValue.replace(/\./g, '').replace(',', '.')
        : textValue

      const parsedValue = Number(normalizedValue)
      return Number.isNaN(parsedValue) ? null : parsedValue
    },
    formatDecimalForMask(value) {
      const parsedValue = this.parseBrazilianNumber(value)

      if (parsedValue === null) {
        return ''
      }

      return parsedValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    normalizeMaskedFieldsForForm() {
      this.getMoneyFields()
        .concat(this.getPercentFields())
        .forEach((field) => {
          if (this.produto[field] !== undefined && this.produto[field] !== null && this.produto[field] !== '') {
            this.$set(this.produto, field, this.formatDecimalForMask(this.produto[field]))
          }
        })
    },
    normalizeNumericFieldsForSubmit() {
      this.getMoneyFields()
        .concat(this.getPercentFields(), this.getNumberFields())
        .forEach((field) => {
          if (this.produto[field] === undefined || this.produto[field] === null || this.produto[field] === '') {
            return
          }

          const parsedValue = this.parseBrazilianNumber(this.produto[field])
          if (parsedValue !== null) {
            this.$set(this.produto, field, parsedValue)
          }
        })
    },
    normalizeDateValue(value) {
      if (!value) {
        return ''
      }

      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value.toISOString().slice(0, 10)
      }

      const textValue = String(value).trim()

      if (/^\d{4}-\d{2}-\d{2}/.test(textValue)) {
        return textValue.slice(0, 10)
      }

      const brasilDate = textValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
      if (brasilDate) {
        return `${brasilDate[3]}-${brasilDate[2]}-${brasilDate[1]}`
      }

      return textValue
    },
    normalizeProdutoParaFormulario() {
      const fields = [
        {
          target: 'categoria',
          options: this.categoryOptions,
          keys: ['categoria', 'categoria_produto', 'categoriaProduto', 'category'],
        },
        {
          target: 'subcategoria',
          options: this.subcategoryOptions,
          keys: ['subcategoria', 'sub_categoria', 'subcategoria_produto', 'subcategory'],
        },
        {
          target: 'marca',
          options: this.brandOptions,
          keys: ['marca', 'marca_produto', 'brand'],
        },
        {
          target: 'fabricante',
          options: this.manufacturerOptions,
          keys: ['fabricante', 'fabricante_produto', 'manufacturer'],
        },
        {
          target: 'tipo_produto_especifico',
          options: this.productTypeOptions,
          keys: ['tipo_produto_especifico', 'tipo_produto', 'tipoProduto', 'tipo', 'product_type'],
        },
        {
          target: 'faixa_etaria',
          options: this.ageRangeOptions,
          keys: ['faixa_etaria', 'faixaEtaria', 'age_range'],
        },
      ]

      fields.forEach(({ target, options, keys }) => {
        const value = this.getFieldValue(this.produto, keys)
        if (value) {
          this.$set(this.produto, target, this.matchOptionValue(options, value))
        }
      })

      const ultimaCompra = this.getFieldValue(this.produto, ['ultima_compra', 'ultimaCompra', 'data_ultima_compra'])
      if (ultimaCompra) {
        this.$set(this.produto, 'ultima_compra', this.normalizeDateValue(ultimaCompra))
      }

      const ativoValue = ['ativo', 'status', 'situacao']
        .map((key) => this.produto && this.produto[key])
        .find((value) => value !== undefined && value !== null && value !== '')

      if (ativoValue !== undefined) {
        this.$set(this.produto, 'ativo', this.normalizeBooleanValue(ativoValue, true))
      }

      const booleanFields = [
        {
          target: 'controla_estoque',
          keys: ['controla_estoque', 'controlaEstoque', 'controlar_estoque', 'controlarEstoque'],
          defaultValue: true,
        },
        {
          target: 'controla_lote',
          keys: ['controla_lote', 'controlaLote', 'controlar_lote', 'controlarLote'],
          defaultValue: false,
        },
        {
          target: 'controla_validade',
          keys: ['controla_validade', 'controlaValidade', 'controlar_validade', 'controlarValidade'],
          defaultValue: false,
        },
        {
          target: 'permite_estoque_negativo',
          keys: ['permite_estoque_negativo', 'permiteEstoqueNegativo', 'estoque_negativo', 'estoqueNegativo'],
          defaultValue: false,
        },
      ]

      booleanFields.forEach(({ target, keys, defaultValue }) => {
        const value = this.getFirstDefinedValue(this.produto, keys)
        if (value !== undefined) {
          this.$set(this.produto, target, this.normalizeBooleanValue(value, defaultValue))
        }
      })

      this.normalizeMaskedFieldsForForm()
    },
    getProdutorOptionsPayload(response) {
      const payload = response && response.data ? response.data : {}

      if (Array.isArray(payload.data)) {
        return payload.data
      }

      if (Array.isArray(payload.produtores)) {
        return payload.produtores
      }

      if (Array.isArray(payload.dados)) {
        return payload.dados
      }

      if (Array.isArray(payload.items)) {
        return payload.items
      }

      return []
    },
    getProdutorOptionLabel(item) {
      if (!item) {
        return ''
      }

      const nome = item.nome || item.razao_social || item.nome_fantasia || item.cliente || item.fornecedor || ''
      const documento = item.cpf_cnpj || item.cpfcnpj || item.cpf || item.cnpj || ''

      return [nome, documento].filter(Boolean).join(' - ')
    },
    syncFornecedorFromTerm() {
      this.syncProdutorAutocompleteField('fornecedor_principal', this.fornecedorAutocompleteTerm)
    },
    syncFabricanteFromTerm() {
      this.syncProdutorAutocompleteField('fabricante', this.fabricanteAutocompleteTerm)
    },
    syncProdutorAutocompleteField(field, term) {
      const termo = term
        ? String(term).trim()
        : ''

      this.$set(this.produto, field, termo)
    },
    handleFornecedorAutocompleteInput() {
      this.handleProdutorAutocompleteInput('fornecedor')
    },
    handleFabricanteAutocompleteInput() {
      this.handleProdutorAutocompleteInput('fabricante')
    },
    handleProdutorAutocompleteInput(tipo) {
      const isFabricante = tipo === 'fabricante'
      const termoAtual = isFabricante ? this.fabricanteAutocompleteTerm : this.fornecedorAutocompleteTerm
      this.syncProdutorAutocompleteField(isFabricante ? 'fabricante' : 'fornecedor_principal', termoAtual)

      const termo = termoAtual
        ? String(termoAtual).trim()
        : ''

      if (isFabricante) {
        this.showFabricanteAutocomplete = termo.length > 0
      } else {
        this.showFornecedorAutocomplete = termo.length > 0
      }

      this.handleBuscarProdutores(termo, tipo)
    },
    handleFornecedorAutocompleteFocus() {
      this.handleProdutorAutocompleteFocus('fornecedor')
    },
    handleFabricanteAutocompleteFocus() {
      this.handleProdutorAutocompleteFocus('fabricante')
    },
    handleProdutorAutocompleteFocus(tipo) {
      const isFabricante = tipo === 'fabricante'
      const termoAtual = isFabricante ? this.fabricanteAutocompleteTerm : this.fornecedorAutocompleteTerm
      const termo = termoAtual
        ? String(termoAtual).trim()
        : ''

      if (isFabricante) {
        this.showFabricanteAutocomplete = true
      } else {
        this.showFornecedorAutocomplete = true
      }
      this.carregarFornecedores(termo)
    },
    handleFornecedorAutocompleteBlur() {
      this.handleProdutorAutocompleteBlur('fornecedor')
    },
    handleFabricanteAutocompleteBlur() {
      this.handleProdutorAutocompleteBlur('fabricante')
    },
    handleProdutorAutocompleteBlur(tipo) {
      setTimeout(() => {
        if (tipo === 'fabricante') {
          this.showFabricanteAutocomplete = false
          return
        }
        this.showFornecedorAutocomplete = false
      }, 180)
    },
    handleSelecionarFornecedor(item) {
      this.handleSelecionarProdutorAutocomplete(item, 'fornecedor')
    },
    handleSelecionarFabricante(item) {
      this.handleSelecionarProdutorAutocomplete(item, 'fabricante')
    },
    handleSelecionarProdutorAutocomplete(item, tipo) {
      const label = this.getProdutorOptionLabel(item)
      if (tipo === 'fabricante') {
        this.fabricanteAutocompleteTerm = label
        this.$set(this.produto, 'fabricante', label)
        this.showFabricanteAutocomplete = false
        return
      }

      this.fornecedorAutocompleteTerm = label
      this.$set(this.produto, 'fornecedor_principal', label)
      this.showFornecedorAutocomplete = false
    },
    handleBuscarFornecedores(search) {
      this.handleBuscarProdutores(search, 'fornecedor')
    },
    handleBuscarProdutores(search, tipo = 'fornecedor') {
      const termo = search ? String(search).trim() : ''
      const debounceField = tipo === 'fabricante'
        ? 'fabricanteSearchDebounce'
        : 'fornecedorSearchDebounce'

      if (this[debounceField]) {
        clearTimeout(this[debounceField])
      }

      this[debounceField] = setTimeout(() => {
        this.carregarFornecedores(termo)
      }, 250)
    },
    carregarFornecedores(search = '') {
      const token = this.$store.state.auth.currentUser.token
      const termo = search ? String(search).trim() : ''

      this.isLoadingFornecedores = true

      const request = termo
        ? produtorRuralService.listarByFilter(token, termo, 1, 20)
        : produtorRuralService.listar(token, 1, 20)

      return request
        .then((response) => {
          this.produtores = this.getProdutorOptionsPayload(response)
        })
        .catch(() => {
          this.produtores = []
        })
        .finally(() => {
          this.isLoadingFornecedores = false
        })
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      Produto.listar(token)
        .then((response) => {
          this.mapas = response.data.dados || response.data.produtos || []
        })
        .catch(() => {
          this.mapas = []
        })
    },
    getArquivoField(tipo) {
      const fields = {
        foto_principal: 'foto_principal_url',
        fotos_secundarias: 'fotos_secundarias_urls',
        anexos: 'anexos_urls',
        bula: 'bula_url',
        fispq: 'fispq_url',
        manual: 'manual_url',
      }

      return fields[tipo]
    },
    getArquivoLinks(tipo) {
      const field = this.getArquivoField(tipo)
      const value = field ? this.produto[field] : null

      if (!value) {
        return []
      }

      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }

      if (typeof value === 'string') {
        return value
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean)
      }

      return []
    },
    getArquivoResumo(tipo, placeholder) {
      const files = this.arquivoUploads[tipo] || []

      if (files.length) {
        return files.length === 1 ? files[0].name : `${files.length} arquivos selecionados`
      }

      const links = this.getArquivoLinks(tipo)
      if (links.length) {
        return links.length === 1 ? 'Arquivo salvo' : `${links.length} arquivos salvos`
      }

      return placeholder
    },
    isArquivoImagem(arquivo) {
      const mime = arquivo && arquivo.type ? arquivo.type : ''
      const name = arquivo && arquivo.name ? arquivo.name : ''
      const url = arquivo && arquivo.url ? arquivo.url : ''

      return mime.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/i.test(name || url)
    },
    getNomeArquivo(url) {
      if (!url) {
        return ''
      }

      const cleanUrl = String(url).split('?')[0]
      const nome = cleanUrl.split('/').pop()
      return nome || 'Arquivo salvo'
    },
    limparArquivoPreviews(tipo = null) {
      const tipos = tipo ? [tipo] : Object.keys(this.arquivoPreviews)

      tipos.forEach((itemTipo) => {
        const previews = this.arquivoPreviews[itemTipo] || []
        previews.forEach((preview) => {
          if (preview.objectUrl && window.URL && window.URL.revokeObjectURL) {
            window.URL.revokeObjectURL(preview.objectUrl)
          }
        })
        this.$set(this.arquivoPreviews, itemTipo, [])
      })
    },
    getArquivoPreviewItems(tipo) {
      const previews = this.arquivoPreviews[tipo] || []

      if (previews.length) {
        return previews
      }

      return this.getArquivoLinks(tipo).map((url) => ({
        name: this.getNomeArquivo(url),
        url,
        isImage: this.isArquivoImagem({ url }),
        saved: true,
      }))
    },
    temArquivoParaRemover(tipo) {
      return (this.arquivoUploads[tipo] || []).length > 0 || this.getArquivoLinks(tipo).length > 0
    },
    removerArquivo(tipo, index = null) {
      const uploads = this.arquivoUploads[tipo] || []
      const hasUpload = uploads.length > 0

      if (hasUpload) {
        if (index === null) {
          this.$set(this.arquivoUploads, tipo, [])
          this.limparArquivoPreviews(tipo)
          return
        }

        const files = uploads.filter((_, fileIndex) => fileIndex !== index)
        const previews = (this.arquivoPreviews[tipo] || []).filter((_, previewIndex) => previewIndex !== index)
        const previewRemovido = (this.arquivoPreviews[tipo] || [])[index]

        if (previewRemovido && previewRemovido.objectUrl && window.URL && window.URL.revokeObjectURL) {
          window.URL.revokeObjectURL(previewRemovido.objectUrl)
        }

        this.$set(this.arquivoUploads, tipo, files)
        this.$set(this.arquivoPreviews, tipo, previews)
        return
      }

      const field = this.getArquivoField(tipo)
      if (!field) {
        return
      }

      const links = this.getArquivoLinks(tipo)
      const multipleFields = ['fotos_secundarias_urls', 'anexos_urls']

      if (multipleFields.includes(field)) {
        const novosLinks = index === null
          ? []
          : links.filter((_, linkIndex) => linkIndex !== index)

        this.$set(this.produto, field, novosLinks)
        return
      }

      this.$set(this.produto, field, '')
    },
    handleSelecionarArquivo(tipo, event, multiple = false) {
      const files = Array.from(event.target.files || [])
      this.$set(this.arquivoUploads, tipo, multiple ? files : files.slice(0, 1))
      this.limparArquivoPreviews(tipo)

      const selectedFiles = multiple ? files : files.slice(0, 1)
      const previews = selectedFiles.map((file) => {
        const isImage = this.isArquivoImagem(file)
        const objectUrl = isImage && window.URL && window.URL.createObjectURL
          ? window.URL.createObjectURL(file)
          : ''

        return {
          name: file.name,
          url: objectUrl,
          objectUrl,
          isImage,
          saved: false,
        }
      })

      this.$set(this.arquivoPreviews, tipo, previews)
    },
    hasArquivosPendentes() {
      return Object.keys(this.arquivoUploads).some((tipo) => this.arquivoUploads[tipo].length > 0)
    },
    getUploadUrl(response) {
      const payload = response && response.data ? response.data : {}

      return payload.url ||
        payload.link ||
        payload.location ||
        payload.caminho ||
        (payload.arquivo && (payload.arquivo.url || payload.arquivo.link)) ||
        (payload.data && (payload.data.url || payload.data.link)) ||
        ''
    },
    registrarArquivoLink(tipo, url) {
      if (!url) {
        return
      }

      const field = this.getArquivoField(tipo)
      if (!field) {
        return
      }

      const multipleFields = ['fotos_secundarias_urls', 'anexos_urls']

      if (multipleFields.includes(field)) {
        const links = this.getArquivoLinks(tipo)
        links.push(url)
        this.$set(this.produto, field, links)
        return
      }

      this.$set(this.produto, field, url)
    },
    limparArquivosSelecionados() {
      Object.keys(this.arquivoUploads).forEach((tipo) => {
        this.$set(this.arquivoUploads, tipo, [])
      })
      this.limparArquivoPreviews()
    },
    async uploadArquivosProduto(token) {
      if (!this.hasArquivosPendentes()) {
        return
      }

      if (!this.produto.id_produto) {
        throw new Error('Produto sem id para envio de arquivos.')
      }

      const tipos = Object.keys(this.arquivoUploads)

      for (const tipo of tipos) {
        const files = this.arquivoUploads[tipo] || []

        for (const file of files) {
          const response = await Produto.uploadArquivo(token, this.produto.id_produto, tipo, file)
          this.registrarArquivoLink(tipo, this.getUploadUrl(response))
        }
      }

      await Produto.update(token, this.produto)
      this.limparArquivosSelecionados()
    },
    preencherProdutoMock() {
      const suffix = String(Date.now()).slice(-6)
      const unidadeCompra = this.unidades[0] || {}
      const unidadeVenda = this.unidades[1] || this.unidades[0] || {}
      const fornecedor = this.produtores[0] ? this.getProdutorOptionLabel(this.produtores[0]) : 'Fornecedor Teste'
      const mapa = this.mapas[0] || {}

      const mock = {
        cod_erp: `PRD-TESTE-${suffix}`,
        ean: `7890000${suffix}`,
        sku: `SKU-TESTE-${suffix}`,
        nome: `Produto Teste ${suffix}`,
        nome_reduzido: `Teste ${suffix}`,
        descricao: 'Produto preenchido automaticamente para testes de cadastro.',
        categoria: 'Defensivos',
        subcategoria: 'Herbicidas',
        marca: 'AgroMax',
        fabricante: 'Bayer',
        linha_produto: 'Linha Teste',
        ativo: true,
        controla_estoque: true,
        controla_lote: true,
        controla_validade: true,
        permite_estoque_negativo: false,
        estoque_disponivel: 0,
        estoque_minimo: 5,
        estoque_maximo: 100,
        estoque_ideal: 50,
        ponto_reposicao: 10,
        id_unidade_compra: unidadeCompra.id || unidadeCompra.id_unidade || null,
        id_unidade: unidadeVenda.id || unidadeVenda.id_unidade || null,
        fator_conversao: 1,
        custo_reposicao: 85,
        valor_venda: 120,
        preco_promocional: 110,
        margem_percentual: 30,
        comissao_vendedor_percentual: 5,
        ncm: '3808.91.99',
        cest: '00.000.00',
        cfop_padrao: '5102',
        origem_mercadoria: '0 - Nacional',
        cst_icms: '00',
        csosn: '102',
        cst_pis: '01',
        cst_cofins: '01',
        aliquota_icms: 18,
        aliquota_pis: 1.65,
        aliquota_cofins: 7.6,
        fornecedor_principal: fornecedor,
        codigo_fornecedor: `FORN-${suffix}`,
        prazo_medio_entrega: 7,
        tipo_produto_especifico: 'Defensivo',
        mapa: mapa.mapa || mapa.registro || `MAPA-${suffix}`,
        registro_anvisa: `ANVISA-${suffix}`,
        especies_animais: [],
        faixa_etaria: 'Todas as idades',
        volume: '1 L',
      }

      Object.keys(mock).forEach((key) => {
        this.$set(this.produto, key, mock[key])
      })

      this.normalizeMaskedFieldsForForm()
      this.fornecedorAutocompleteTerm = fornecedor
      this.activeTab = 0

      this.$bvToast.toast('Campos preenchidos com dados de teste.', {
        variant: 'info',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    async salvarProduto(resetAfterSave = false) {
      const token = this.$store.state.auth.currentUser.token
      this.ensureProductDefaults()
      this.normalizeNumericFieldsForSubmit()
      this.produto.desc_antidoto_tratamento = ''
      this.produto.desc_precaucao_uso = ''
      this.produto.desc_epi = ''
      this.produto.desc_primeiro_socorro = ''

      this.setLoading(true)
      const request = this.produto.id_produto
        ? Produto.update(token, this.produto)
        : Produto.salvar(token, this.produto)

      try {
        const resposta = await request
        if (!this.produto.id_produto && resposta.data && resposta.data.sucesso) {
          this.produto.id_produto = resposta.data.sucesso.idProduto
        }

        await this.uploadArquivosProduto(token)
        this.normalizeMaskedFieldsForForm()

        this.$bvToast.toast(this.produto.id_produto ? 'Produto salvo com sucesso!' : 'Salvo com sucesso!', {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        this.$emit('onSave', { produto: this.produto, resetAfterSave })

        if (resetAfterSave) {
          Object.keys(this.produto).forEach((key) => {
            this.$delete(this.produto, key)
          })
          this.ensureProductDefaults()
          this.normalizeMaskedFieldsForForm()
          this.limparArquivosSelecionados()
          this.activeTab = 0
        }
      } catch (erro) {
        const mensagem =
          erro.response && erro.response.data && Array.isArray(erro.response.data.data)
            ? erro.response.data.data.join(', ')
            : 'Erro inesperado ao salvar o produto'

        this.$bvToast.toast(mensagem, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.normalizeMaskedFieldsForForm()
        this.setLoading(false)
      }
    },
    handleGetTiposProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.setLoading(true)
      tipoProdutoService
        .listar(token)
        .then((response) => {
          this.tipos_produto = response.data.tipos || []
        })
        .finally(() => this.setLoading(false))
    },
    handleGetUnidade() {
      const token = this.$store.state.auth.currentUser.token
      this.setLoading(true)
      unidadeService
        .listar(token)
        .then((response) => {
          this.unidades = response.data.unidades || []
        })
        .finally(() => this.setLoading(false))
    },
    handleGetProdutores() {
      const token = this.$store.state.auth.currentUser.token
      this.setLoading(true)
      produtorRuralService
        .listar(token, 1, 100)
        .then((response) => {
          this.produtores = this.getProdutorOptionsPayload(response)
        })
        .catch(() => {
          this.produtores = []
        })
        .finally(() => this.setLoading(false))
    },
  },
}
</script>

<template>
  <div class="product-registration">
    <b-form>
      <div class="product-test-actions">
        <b-button variant="outline-secondary" size="sm" @click="preencherProdutoMock">
          <i class="uil uil-flask"></i>
          Preencher mock
        </b-button>
      </div>

      <b-tabs v-model="activeTab" class="product-tabs" content-class="product-tab-content">
        <b-tab title="Dados Gerais" active>
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-clipboard-notes"></i>
              <span>Identificação</span>
            </div>

            <div class="product-grid three">
              <b-form-group label="Código Interno *">
                <b-form-input v-model="produto.cod_erp" placeholder="PRD-0001" required />
              </b-form-group>
              <b-form-group label="Código de Barras / EAN">
                <b-form-input v-model="produto.ean" placeholder="7890000000001" />
              </b-form-group>
              <b-form-group label="SKU">
                <b-form-input v-model="produto.sku" placeholder="PROD-CAT-01" />
              </b-form-group>
            </div>

            <div class="product-grid two-one">
              <b-form-group label="Nome do Produto *">
                <b-form-input v-model="produto.nome" placeholder="Digite o nome completo do produto" required />
              </b-form-group>
              <b-form-group label="Nome Reduzido">
                <b-form-input v-model="produto.nome_reduzido" placeholder="Nome para etiquetas e pedidos" />
              </b-form-group>
            </div>

            <b-form-group label="Descrição">
              <b-form-textarea v-model="produto.descricao" placeholder="Descrição comercial do produto" rows="4" />
            </b-form-group>
          </section>

          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-sitemap"></i>
              <span>Classificação</span>
            </div>

            <div class="classification-layout">
              <div class="classification-fields">
                <div class="product-grid three">
                  <b-form-group label="Categoria *">
                    <v-select v-model="produto.categoria" class="style-select" :options="categoryOptions" placeholder="Selecione..." />
                  </b-form-group>
                  <b-form-group label="Subcategoria">
                    <v-select v-model="produto.subcategoria" class="style-select" :options="subcategoryOptions" placeholder="Selecione..." />
                  </b-form-group>
                  <b-form-group label="Marca">
                    <v-select v-model="produto.marca" class="style-select" :options="brandOptions" placeholder="Selecione..." />
                  </b-form-group>
                </div>

                <div class="product-grid two">
                  <b-form-group label="Fabricante">
                    <div class="produtor-autocomplete">
                      <b-form-input
                        v-model="fabricanteAutocompleteTerm"
                        autocomplete="off"
                        placeholder="Pesquisar produtor..."
                        @input="handleFabricanteAutocompleteInput"
                        @focus="handleFabricanteAutocompleteFocus"
                        @blur="handleFabricanteAutocompleteBlur"
                      />
                      <div v-if="showFabricanteAutocomplete" class="produtor-autocomplete-menu">
                        <div v-if="isLoadingFornecedores" class="produtor-autocomplete-state">
                          Buscando produtores...
                        </div>
                        <button
                          v-for="item in produtores"
                          v-else
                          :key="`fabricante-${item.id || item.id_produtor || item.cpf_cnpj || getProdutorOptionLabel(item)}`"
                          type="button"
                          class="produtor-autocomplete-item"
                          @mousedown.prevent="handleSelecionarFabricante(item)"
                        >
                          <span class="produtor-autocomplete-name">{{ getProdutorOptionLabel(item) }}</span>
                          <span v-if="item.endereco" class="produtor-autocomplete-meta">{{ item.endereco }}</span>
                        </button>
                        <div
                          v-if="!isLoadingFornecedores && produtores.length === 0"
                          class="produtor-autocomplete-state"
                        >
                          Nenhum produtor encontrado.
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                  <b-form-group label="Linha de Produto">
                    <b-form-input v-model="produto.linha_produto" placeholder="Ex.: Premium, Campo, Pet Care" />
                  </b-form-group>
                </div>
              </div>

              <aside class="status-card">
                <div class="status-card-title">
                  <i class="uil uil-toggle-on"></i>
                  <span>Situação</span>
                </div>
                <small>Estado atual do produto</small>
                <b-form-radio-group v-model="produto.ativo" :options="situationOptions" stacked />
                <p>Produtos ativos ficam disponíveis em orçamentos, vendas e pedidos.</p>
              </aside>
            </div>
          </section>
        </b-tab>

        <b-tab title="Estoque">
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-cube"></i>
              <span>Controle de Estoque</span>
            </div>

            <div class="switch-grid">
              <b-form-checkbox v-model="produto.controla_estoque" switch>Controla Estoque</b-form-checkbox>
              <b-form-checkbox v-model="produto.controla_lote" switch>Controla Lote</b-form-checkbox>
              <b-form-checkbox v-model="produto.controla_validade" switch>Controla Validade</b-form-checkbox>
              <b-form-checkbox v-model="produto.permite_estoque_negativo" switch>Permite Estoque Negativo</b-form-checkbox>
            </div>

            <div class="product-grid five">
              <b-form-group label="Estoque Atual">
                <b-form-input v-model="produto.estoque_disponivel" type="number" readonly />
              </b-form-group>
              <b-form-group label="Estoque Mínimo">
                <b-form-input v-model="produto.estoque_minimo" type="number" />
              </b-form-group>
              <b-form-group label="Estoque Máximo">
                <b-form-input v-model="produto.estoque_maximo" type="number" />
              </b-form-group>
              <b-form-group label="Estoque Ideal">
                <b-form-input v-model="produto.estoque_ideal" type="number" />
              </b-form-group>
              <b-form-group label="Ponto de Reposição">
                <b-form-input v-model="produto.ponto_reposicao" type="number" />
              </b-form-group>
            </div>

            <div class="product-grid three">
              <b-form-group label="Unidade de Compra">
                <v-select v-model="produto.id_unidade_compra" class="style-select" :options="unidades" :reduce="(item) => item.id" label="unid1" placeholder="Selecione..." />
              </b-form-group>
              <b-form-group label="Unidade de Venda">
                <v-select v-model="produto.id_unidade" class="style-select" :options="unidades" :reduce="(item) => item.id" label="unid1" placeholder="Selecione..." />
              </b-form-group>
              <b-form-group label="Fator de Conversão">
                <b-form-input v-model="produto.fator_conversao" type="number" step="0.0001" />
              </b-form-group>
            </div>
          </section>
        </b-tab>

        <b-tab title="Preços">
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-usd-circle"></i>
              <span>Política Comercial</span>
            </div>

            <div class="product-grid three">
              <b-form-group label="Custo Médio">
                <b-form-input v-model.lazy="produto.custo_medio" v-money="money" readonly />
              </b-form-group>
              <b-form-group label="Último Custo">
                <b-form-input v-model.lazy="produto.ultimo_custo" v-money="money" readonly />
              </b-form-group>
              <b-form-group label="Custo de Reposição">
                <b-form-input v-model.lazy="produto.custo_reposicao" v-money="money" />
              </b-form-group>
            </div>

            <div class="product-grid four">
              <b-form-group label="Preço de Venda *">
                <b-form-input v-model.lazy="produto.valor_venda" v-money="money" required />
              </b-form-group>
              <b-form-group label="Preço Promocional">
                <b-form-input v-model.lazy="produto.preco_promocional" v-money="money" />
              </b-form-group>
              <b-form-group label="Margem %">
                <b-form-input v-model.lazy="produto.margem_percentual" v-money="percentMoney" />
              </b-form-group>
              <b-form-group label="Comissão Vendedor %">
                <b-form-input v-model.lazy="produto.comissao_vendedor_percentual" v-money="percentMoney" />
              </b-form-group>
            </div>
          </section>
        </b-tab>

        <b-tab title="Fiscal">
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-file-check-alt"></i>
              <span>Dados Fiscais</span>
            </div>

            <div class="product-grid four">
              <b-form-group label="NCM">
                <b-form-input v-model="produto.ncm" placeholder="0000.00.00" />
              </b-form-group>
              <b-form-group label="CEST">
                <b-form-input v-model="produto.cest" placeholder="00.000.00" />
              </b-form-group>
              <b-form-group label="CFOP Padrão">
                <b-form-input v-model="produto.cfop_padrao" placeholder="5102" />
              </b-form-group>
              <b-form-group label="Origem da Mercadoria">
                <b-form-select v-model="produto.origem_mercadoria" :options="originOptions" />
              </b-form-group>
            </div>

            <div class="product-grid four">
              <b-form-group label="CST ICMS">
                <b-form-select v-model="produto.cst_icms" :options="cstIcmsOptions" />
              </b-form-group>
              <b-form-group label="CSOSN">
                <b-form-select v-model="produto.csosn" :options="csosnOptions" />
              </b-form-group>
              <b-form-group label="CST PIS">
                <b-form-select v-model="produto.cst_pis" :options="pisCofinsOptions" />
              </b-form-group>
              <b-form-group label="CST COFINS">
                <b-form-select v-model="produto.cst_cofins" :options="pisCofinsOptions" />
              </b-form-group>
            </div>

            <div class="product-grid three">
              <b-form-group label="Alíquota ICMS %">
                <b-form-input v-model="produto.aliquota_icms" type="number" step="0.01" />
              </b-form-group>
              <b-form-group label="Alíquota PIS %">
                <b-form-input v-model="produto.aliquota_pis" type="number" step="0.01" />
              </b-form-group>
              <b-form-group label="Alíquota COFINS %">
                <b-form-input v-model="produto.aliquota_cofins" type="number" step="0.01" />
              </b-form-group>
            </div>
          </section>
        </b-tab>

        <b-tab title="Fornecedores">
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-truck"></i>
              <span>Fornecedor Principal</span>
            </div>

            <div class="product-grid two">
              <b-form-group label="Fornecedor Principal">
                <div class="produtor-autocomplete">
                  <b-form-input
                    v-model="fornecedorAutocompleteTerm"
                    autocomplete="off"
                    placeholder="Digite para buscar clientes ou fornecedores"
                    @input="handleFornecedorAutocompleteInput"
                    @change="syncFornecedorFromTerm"
                    @focus="handleFornecedorAutocompleteFocus"
                    @blur="handleFornecedorAutocompleteBlur"
                  />
                  <div v-if="showFornecedorAutocomplete" class="produtor-autocomplete-menu">
                    <div v-if="isLoadingFornecedores" class="produtor-autocomplete-state">
                      Buscando clientes e fornecedores...
                    </div>
                    <button
                      v-for="item in produtores"
                      v-else
                      :key="item.id_produtor_rural || item.id_cliente || item.id"
                      type="button"
                      class="produtor-autocomplete-item"
                      @mousedown.prevent="handleSelecionarFornecedor(item)"
                    >
                      <span class="produtor-autocomplete-name">{{ getProdutorOptionLabel(item) }}</span>
                      <span v-if="item.endereco" class="produtor-autocomplete-meta">{{ item.endereco }}</span>
                    </button>
                    <div
                      v-if="!isLoadingFornecedores && !produtores.length"
                      class="produtor-autocomplete-state"
                    >
                      Nenhum cliente ou fornecedor encontrado.
                    </div>
                  </div>
                </div>
              </b-form-group>
              <b-form-group label="Código do Produto no Fornecedor">
                <b-form-input v-model="produto.codigo_fornecedor" placeholder="Código usado pelo fornecedor" />
              </b-form-group>
            </div>

            <div class="product-grid three">
              <b-form-group label="Última Compra">
                <b-form-datepicker
                  id="datepicker-ultima-compra"
                  v-model="produto.ultima_compra"
                  class="product-date-control"
                  placeholder="Data da última compra"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  locale="pt-br"
                >
                  <template v-slot:button-content>
                    <b-icon icon="calendar" variant="primary"></b-icon>
                  </template>
                </b-form-datepicker>
              </b-form-group>
              <b-form-group label="Último Preço de Compra">
                <b-form-input v-model.lazy="produto.ultimo_preco_compra" v-money="money" readonly />
              </b-form-group>
              <b-form-group label="Prazo Médio de Entrega">
                <b-input-group append="dias">
                  <b-form-input v-model="produto.prazo_medio_entrega" type="number" />
                </b-input-group>
              </b-form-group>
            </div>
          </section>
        </b-tab>

        <b-tab title="Agro / Pet">
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-leaf"></i>
              <span>Dados Específicos</span>
            </div>

            <div class="product-grid three">
              <b-form-group label="Tipo de Produto">
                <b-form-select v-model="produto.tipo_produto_especifico" :options="productTypeOptions" />
              </b-form-group>
              <b-form-group label="Registro MAPA">
                <b-input-group>
                  <b-form-input v-model="produto.mapa" placeholder="Registro MAPA" />
                  <b-input-group-append>
                    <b-button variant="outline-secondary" @click="$bvModal.show('modal-mapa')">Ver</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group label="Registro ANVISA">
                <b-form-input v-model="produto.registro_anvisa" placeholder="Registro sanitário" />
              </b-form-group>
            </div>

            <div class="product-grid three">
              <b-form-group label="Espécie Animal">
                <v-select v-model="produto.especies_animais" class="style-select" :options="animalOptions" multiple placeholder="Selecione..." />
              </b-form-group>
              <b-form-group label="Faixa Etária">
                <b-form-select v-model="produto.faixa_etaria" :options="ageRangeOptions" />
              </b-form-group>
              <b-form-group label="Peso/Volume da Embalagem">
                <b-form-input v-model="produto.volume" placeholder="Ex.: 1 L, 20 kg, 500 ml" />
              </b-form-group>
            </div>
          </section>
        </b-tab>

        <b-tab title="Arquivos e Imagens">
          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-images"></i>
              <span>Imagens do Produto</span>
            </div>

            <div class="upload-grid">
              <label class="upload-card">
                <div v-if="getArquivoPreviewItems('foto_principal').length" class="upload-preview single">
                  <img
                    v-if="getArquivoPreviewItems('foto_principal')[0].isImage"
                    :src="getArquivoPreviewItems('foto_principal')[0].url"
                    :alt="getArquivoPreviewItems('foto_principal')[0].name"
                  />
                  <i v-else class="uil uil-file-check-alt"></i>
                </div>
                <i v-else class="uil uil-image-upload"></i>
                <strong>Foto Principal</strong>
                <span>{{ getArquivoResumo('foto_principal', 'PNG ou JPG') }}</span>
                <button v-if="temArquivoParaRemover('foto_principal')" type="button" class="upload-remove" @click.prevent.stop="removerArquivo('foto_principal')">
                  Remover
                </button>
                <input type="file" accept="image/*" @change="handleSelecionarArquivo('foto_principal', $event)" />
              </label>
              <label class="upload-card">
                <div v-if="getArquivoPreviewItems('fotos_secundarias').length" class="upload-preview gallery">
                  <template v-for="(arquivo, index) in getArquivoPreviewItems('fotos_secundarias').slice(0, 4)">
                    <img v-if="arquivo.isImage" :key="`foto-secundaria-${index}`" :src="arquivo.url" :alt="arquivo.name" />
                    <div v-else :key="`foto-secundaria-file-${index}`" class="upload-file-thumb">
                      <i class="uil uil-file-check-alt"></i>
                    </div>
                  </template>
                </div>
                <i v-else class="uil uil-layer-group"></i>
                <strong>Fotos Secundárias</strong>
                <span>{{ getArquivoResumo('fotos_secundarias', 'Envio múltiplo') }}</span>
                <button v-if="temArquivoParaRemover('fotos_secundarias')" type="button" class="upload-remove" @click.prevent.stop="removerArquivo('fotos_secundarias')">
                  Remover
                </button>
                <input type="file" accept="image/*" multiple @change="handleSelecionarArquivo('fotos_secundarias', $event, true)" />
              </label>
            </div>
          </section>

          <section class="product-section">
            <div class="section-title">
              <i class="uil uil-paperclip"></i>
              <span>Documentos</span>
            </div>

            <div class="upload-grid four">
              <label class="upload-card compact">
                <div v-if="getArquivoPreviewItems('anexos').length" class="upload-file-list">
                  <span v-for="(arquivo, index) in getArquivoPreviewItems('anexos').slice(0, 2)" :key="`anexo-${index}`">
                    <i class="uil uil-file-check-alt"></i>
                    {{ arquivo.name }}
                  </span>
                </div>
                <i v-else class="uil uil-file-upload"></i>
                <strong>Anexos</strong>
                <span>{{ getArquivoResumo('anexos', 'PDF/XML/JPG/PNG') }}</span>
                <button v-if="temArquivoParaRemover('anexos')" type="button" class="upload-remove" @click.prevent.stop="removerArquivo('anexos')">
                  Remover
                </button>
                <input type="file" accept=".pdf,.xml,.jpg,.jpeg,.png" multiple @change="handleSelecionarArquivo('anexos', $event, true)" />
              </label>
              <label class="upload-card compact">
                <div v-if="getArquivoPreviewItems('bula').length" class="upload-file-list single">
                  <span>
                    <i class="uil uil-file-check-alt"></i>
                    {{ getArquivoPreviewItems('bula')[0].name }}
                  </span>
                </div>
                <i v-else class="uil uil-file-alt"></i>
                <strong>Bula</strong>
                <span>{{ getArquivoResumo('bula', 'PDF') }}</span>
                <button v-if="temArquivoParaRemover('bula')" type="button" class="upload-remove" @click.prevent.stop="removerArquivo('bula')">
                  Remover
                </button>
                <input type="file" accept=".pdf" @change="handleSelecionarArquivo('bula', $event)" />
              </label>
              <label class="upload-card compact">
                <div v-if="getArquivoPreviewItems('fispq').length" class="upload-file-list single">
                  <span>
                    <i class="uil uil-file-check-alt"></i>
                    {{ getArquivoPreviewItems('fispq')[0].name }}
                  </span>
                </div>
                <i v-else class="uil uil-shield-check"></i>
                <strong>FISPQ</strong>
                <span>{{ getArquivoResumo('fispq', 'PDF') }}</span>
                <button v-if="temArquivoParaRemover('fispq')" type="button" class="upload-remove" @click.prevent.stop="removerArquivo('fispq')">
                  Remover
                </button>
                <input type="file" accept=".pdf" @change="handleSelecionarArquivo('fispq', $event)" />
              </label>
              <label class="upload-card compact">
                <div v-if="getArquivoPreviewItems('manual').length" class="upload-file-list single">
                  <span>
                    <i class="uil uil-file-check-alt"></i>
                    {{ getArquivoPreviewItems('manual')[0].name }}
                  </span>
                </div>
                <i v-else class="uil uil-book-open"></i>
                <strong>Manual</strong>
                <span>{{ getArquivoResumo('manual', 'PDF') }}</span>
                <button v-if="temArquivoParaRemover('manual')" type="button" class="upload-remove" @click.prevent.stop="removerArquivo('manual')">
                  Remover
                </button>
                <input type="file" accept=".pdf" @change="handleSelecionarArquivo('manual', $event)" />
              </label>
            </div>
          </section>
        </b-tab>
      </b-tabs>

      <b-modal id="modal-mapa" title="Relação Códigos de M.A.P.A" title-class="font-18">
        <b-form-group id="input-filter-mapa" label="Pesquisar Produto" label-for="filter">
          <v-select v-model="filter" class="style-select" label="nome" :options="mapas" :reduce="(mapa) => mapa.nome" />
        </b-form-group>
        <b-table striped hover responsive="sm" borderless bordered outlined small :items="mapas" :fields="mapasFields" :filter="filter" />
        <template v-slot:modal-footer>
          <b-button variant="primary" @click="$bvModal.hide('modal-mapa')">OK</b-button>
        </template>
      </b-modal>
    </b-form>

    <b-overlay :show="isLoading" no-wrap />
  </div>
</template>

<style scoped lang="scss">
.product-registration {
  color: #172033;
}

.product-test-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    font-weight: 700;
  }
}

.product-tabs {
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  overflow: visible;
  background: #ffffff;

  ::v-deep .nav-tabs {
    border-bottom: 1px solid #dfe6ef;
    background: #eef3fb;
    padding: 0 12px;
  }

  ::v-deep .nav-link {
    border: 0;
    color: #172033;
    font-size: 13px;
    font-weight: 600;
    padding: 13px 16px;
  }

  ::v-deep .nav-link.active {
    color: #008e75;
    background: #ffffff;
    box-shadow: inset 0 -2px 0 #008e75;
  }
}

.product-tabs {
  ::v-deep .product-tab-content,
  ::v-deep .tab-content {
    padding: 18px 20px;
    overflow: visible;
  }
}

.product-section {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #edf1f5;

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: 0;
  }
}

.product-section > .form-group,
.product-section > .product-grid,
.classification-layout,
.switch-grid,
.upload-grid {
  max-width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  color: #008e75;
  font-size: 16px;
  font-weight: 700;

  i {
    font-size: 20px;
  }
}

.product-grid {
  display: grid;
  gap: 16px 18px;
  margin-bottom: 16px;

  &.two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  &.two-one {
    grid-template-columns: 2fr 1fr;
  }

  &.three {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  &.four {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  &.five {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

::v-deep .form-group {
  margin-bottom: 0;
}

::v-deep label,
::v-deep legend {
  color: #172033;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
}

::v-deep .form-control,
::v-deep .custom-select,
::v-deep .vs__dropdown-toggle {
  min-height: 36px;
  border-color: #d8dee8;
  border-radius: 5px;
  color: #172033;
  box-shadow: none;
}

::v-deep .form-control,
::v-deep .custom-select {
  padding: 7px 12px;
}

::v-deep .product-date-control.b-form-btn-label-control.form-control {
  display: flex;
  align-items: center;
  min-height: 36px;
  height: 38px;
  padding: 0;
  overflow: visible;
  background-color: #fff;
}

::v-deep .product-date-control.b-form-btn-label-control.form-control > .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 100%;
  padding: 0;
  border: 0;
  color: #008e75;
  background: transparent;
  box-shadow: none;
}

::v-deep .product-date-control.b-form-btn-label-control.form-control > .btn:hover,
::v-deep .product-date-control.b-form-btn-label-control.form-control > .btn:focus {
  color: #008e75;
  background: #f2fbf8;
  box-shadow: none;
}

::v-deep .product-date-control.b-form-btn-label-control.form-control > label {
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 7px 12px 7px 0;
  color: #172033;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
}

::v-deep textarea.form-control {
  min-height: 96px;
  padding-top: 10px;
}

::v-deep .vs__dropdown-toggle {
  padding: 0 8px;
}

::v-deep .vs__selected-options {
  align-items: center;
  padding: 0 4px;
}

::v-deep .vs__selected,
::v-deep .vs__search {
  margin-top: 0;
  min-height: 0;
  height: auto;
  padding: 0;
  border: 0 !important;
  background: transparent;
  color: #172033;
  font-size: 13px;
  line-height: 24px;
  box-shadow: none !important;
  outline: 0;
}

::v-deep .vs__search:focus {
  border: 0 !important;
  box-shadow: none !important;
  outline: 0;
}

::v-deep .vs__actions {
  padding-right: 8px;
}

::v-deep .style-select {
  position: relative;
}

::v-deep .style-select.vs--open {
  z-index: 1050;
}

::v-deep .style-select .vs__dropdown-menu {
  z-index: 1050;
}

::v-deep .form-control:focus,
::v-deep .custom-select:focus,
::v-deep .vs--open .vs__dropdown-toggle {
  border-color: #008e75;
  box-shadow: 0 0 0 3px rgba(0, 142, 117, 0.12);
}

::v-deep input[readonly],
::v-deep input[disabled] {
  background: #eef4fb;
  color: #6a788b;
}

.classification-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 230px;
  gap: 18px;
  align-items: start;
}

.produtor-autocomplete {
  position: relative;
}

.produtor-autocomplete-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 3000;
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #d9e4ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
}

.produtor-autocomplete-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  background: transparent;
  text-align: left;
  transition: background-color 0.15s ease;
}

.produtor-autocomplete-item:hover {
  background: #f1f8f6;
}

.produtor-autocomplete-name {
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
}

.produtor-autocomplete-meta {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.produtor-autocomplete-state {
  padding: 12px;
  color: #64748b;
  font-size: 13px;
}

.status-card {
  padding: 18px 20px;
  border-radius: 7px;
  background: #eaf3ff;
  color: #18324a;

  small {
    display: block;
    margin-bottom: 14px;
    color: #44546a;
    font-weight: 700;
  }

  p {
    margin: 16px 0 0;
    padding: 12px;
    border-radius: 6px;
    background: rgba(0, 142, 117, 0.12);
    color: #29645a;
    font-size: 12px;
    line-height: 1.45;
  }
}

.status-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #008e75;
  font-size: 16px;
  font-weight: 700;
}

.switch-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;

  ::v-deep .custom-control {
    min-height: 38px;
    display: flex;
    align-items: center;
    padding: 10px 12px 10px 42px;
    border: 1px solid #d8e3e8;
    border-radius: 7px;
    background: #f8fbfc;
  }
}

.upload-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  &.four {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.upload-card {
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0;
  border: 1px dashed #bccbd5;
  border-radius: 8px;
  background: #f8fbfc;
  color: #203249;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: #008e75;
    background: #f1fbf8;
  }

  &.compact {
    min-height: 126px;
  }

  i {
    color: #008e75;
    font-size: 30px;
  }

  strong {
    font-size: 14px;
  }

  span {
    color: #6a788b;
    font-size: 12px;
  }

  input {
    display: none;
  }
}

.upload-preview {
  display: grid;
  place-items: center;
  overflow: hidden;
  border-radius: 7px;
  background: #eaf3ef;

  &.single {
    width: 92px;
    height: 58px;
  }

  &.gallery {
    width: 128px;
    height: 58px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 4px;
    padding: 4px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
  }

  i {
    font-size: 26px;
  }
}

.upload-file-thumb {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: #ffffff;
}

.upload-file-list {
  width: min(100%, 230px);
  display: flex;
  flex-direction: column;
  gap: 5px;

  &.single {
    width: min(100%, 190px);
  }

  span {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 6px;
    padding: 5px 8px;
    border-radius: 5px;
    background: #eaf3ef;
    color: #203249;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  i {
    flex: 0 0 auto;
    font-size: 16px;
  }
}

.upload-remove {
  padding: 4px 10px;
  border: 1px solid #ff6b81;
  border-radius: 5px;
  background: #ffffff;
  color: #ff4965;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover,
  &:focus {
    background: #ff4965;
    color: #ffffff;
    outline: 0;
  }
}

@media (max-width: 1200px) {
  .product-tabs {
    ::v-deep .product-tab-content,
    ::v-deep .tab-content {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .product-grid.five,
  .product-grid.four {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .switch-grid,
  .upload-grid.four {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .product-tabs {
    ::v-deep .product-tab-content,
    ::v-deep .tab-content {
      padding: 22px;
    }
  }

  .product-grid.two,
  .product-grid.two-one,
  .product-grid.three,
  .product-grid.four,
  .product-grid.five,
  .classification-layout,
  .switch-grid,
  .upload-grid,
  .upload-grid.four {
    grid-template-columns: 1fr;
  }
}
</style>
